import { render, staticRenderFns } from "./AgreementOrder.vue?vue&type=template&id=c5630578&scoped=true"
import script from "./AgreementOrder.vue?vue&type=script&lang=js"
export * from "./AgreementOrder.vue?vue&type=script&lang=js"
import style0 from "./AgreementOrder.vue?vue&type=style&index=0&id=c5630578&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5630578",
  null
  
)

export default component.exports